import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatDialogModule } from '@angular/material/dialog'
import { ApiModule } from 'src/api/api.module'
import { AddressFormModule } from 'src/components/address-form/address-form.module'
import { AddressPickerModule } from 'src/components/address-picker/address-picker.module'
import { CarrierPickerModule } from 'src/components/carrier-picker/carrier-picker.module'
import { CostsListDialogModule } from 'src/components/costs-list-dialog/costs-list-dialog.module'
import { CreditNoteFormModule } from 'src/components/credits/credit-note-form/credit-note-form.module'
import { VendorCreditFormModule } from 'src/components/credits/vendor-credit/vendor-credit-form.module'
import { CsvFormatterService } from 'src/components/csv-exporter/csv-formatter.service'
import { CsvService } from 'src/components/csv-exporter/csv.service'
import { EmailSelectService } from 'src/components/email-picker/email-select.service'
import { InvoiceScheduleFormModule } from 'src/components/invoices/invoice-schedule-form/invoice-schedule-form.module'
import { MacropointOrderLogOverlayModule } from 'src/components/macropoint-log-overlay/macropoint-order-log-overlay.module'
import { MacropointSegmentConfirmDialogModule } from 'src/components/macropoint-segment-confirm-dialog/macropoint-segment-confirm-dialog.module'
import { MacropointTrackDurationDialogModule } from 'src/components/macropoint-track-duration-dialog/macropoint-track-duration-dialog.module'
import { NoteFormModule } from 'src/components/notes/note-form/note-form.module'
import { NotesOverlayModule } from 'src/components/notes/notes-overlay/notes-overlay.module'
import { ConfigureColumnsService } from 'src/components/table-view/configure-columns/configure-columns.service'
import { SaveViewFormService } from 'src/components/table-view/save-view/save-view.service'
import { ShareViewFormService } from 'src/components/table-view/share-view/share-view.service'
import { UploaderDialogModule } from 'src/components/uploader-dialog/uploader-dialog.module'
import { AddToBuyerGroupsService } from 'src/pages/admin/settings/companies/companies/actions/add-to-buyer-groups/add-to-buyer-groups.service'
import { CreateBuyerGroupService } from 'src/pages/admin/settings/companies/companies/actions/create-buyer-group/create-buyer-group.service'
import { FinanceService } from 'src/pages/admin/auction/matched-offer-overlay/finance.service'
import { MatchedOfferOverlayModule } from 'src/pages/admin/auction/matched-offer-overlay/matched-offer-overlay.module'
import { MatchedOffersService } from 'src/pages/admin/auction/matched-offer-overlay/matched-offers.service'
import { InventoryDealsFormModule } from 'src/components/matched-offers/forms/inventory-deals-form/inventory-deals-form.module'
import { InventoryDealsFormService } from 'src/components/matched-offers/forms/inventory-deals-form/inventory-deals-form.service'
import { MatchedOfferViewLogOverlayModule } from 'src/components/matched-offers/views-overlay/matched-offer-view-log-overlay.module'
import { FutureBidsListOverlayComponent } from 'src/components/matched-offers/future-bids-overlay/future-bids-list-overlay.component'
import { FutureBidsListOverlayService } from 'src/components/matched-offers/future-bids-overlay/future-bids-list-overlay.service'
import { MatchedOfferBidHistoryOverlayService } from 'src/components/matched-offers/bid-history-overlay/matched-offer-bid-history-overlay.service'
import { FutureBidsApiService } from 'src/pages/admin/auction/future-bids/future-bids.service'
import { SupplierOfferOverlayModule } from 'src/pages/admin/auction/supplier-offer-overlay/supplier-offer-overlay.module'
import { FxRatesService } from 'src/pages/admin/financial/fx-rates/fx-rates.service'
import { ReceiptFormModule } from 'src/pages/admin/financial/receipts/form/receipt-form.module'
import { CopyFreightRatesFormModule } from 'src/pages/admin/logistics/freight-rates/copy-freight-rates/copy-freight-rates-form.module'
import { FreightRateFormModule } from 'src/pages/admin/logistics/freight-rates/form/freight-rate-form.module'
import { MacropointOrderTrackingModule } from 'src/pages/admin/logistics/macropoint-order-tracking-page/macropoint-order-tracking-page.module'
import { PackageTrackingService } from 'src/pages/admin/logistics/shipping-logs/detail/overlays/package-tracking/package-tracking.service'
import { SelectStatusNotesFormService } from 'src/pages/admin/logistics/shipping-logs/list/forms/select-status-notes-form/select-status-notes-form.service'
import { BuyerInvoiceReceiptsService } from 'src/pages/admin/management/buyer-invoices/receipts/buyer-invoice-receipts.service'
import { CountriesService } from 'src/pages/admin/settings/admin-setting-geographic/countries.service'
import { BanksService } from 'src/pages/admin/settings/admin-setting-payments/banks/banks.service'
import { CurrenciesService } from 'src/pages/admin/settings/admin-setting-payments/currency/currencies.service'
import { PaymentMethodsService } from 'src/pages/admin/settings/admin-setting-payments/payment-methods/payment-methods.service'
import { PaymentReferencesService } from 'src/pages/admin/settings/admin-setting-payments/payment-references/payment-references.service'
import { PricingTermsService } from 'src/pages/admin/settings/admin-setting-payments/pricing-terms/pricing-terms.service'
import { CompanyCreditFormModule } from 'src/pages/admin/settings/companies/companies/company-credit-form/company-credit-form.module'
import { CompanyFormModule } from 'src/pages/admin/settings/companies/companies/company-form/company-form.module'
import { CompanyLogOverlayModule } from 'src/pages/admin/settings/companies/companies/company-log-overlay/company-log-overlay.module'
import { TemplateLogOverlayModule } from 'src/pages/admin/settings/templates/template-log-overlay/template-log-overlay.module'
import { TriggerLogOverlayModule } from 'src/pages/admin/settings/triggers/trigger-log-overlay/trigger-log-overlay.module'
import { CompanyStatusFormModule } from 'src/pages/admin/settings/companies/companies/company-status-form/company-status-form.module'
import { CustomTagsService } from 'src/pages/admin/settings/custom-tags/custom-tags.service'
import { DocumentFormModule } from 'src/pages/admin/settings/document-library/documents/form/document-form.module'
import { DocumentTagsOverlayModule } from 'src/pages/admin/settings/document-library/tags/document-tags-overlay/document-tags-overlay.module'
import { GeoService } from 'src/pages/admin/settings/locations/location-form/geo.service'
import { LocationsService } from 'src/pages/admin/settings/locations/locations.service'
import { ProductFormModule } from 'src/pages/admin/settings/products-services/product-form/product-form.module'
import { CarriersService } from 'src/pages/admin/settings/tracking-providers/carriers.service'
import { TrackingProvidersService } from 'src/pages/admin/settings/tracking-providers/tracking-providers.service'
import { TransitTimeFormModule } from 'src/pages/admin/settings/transit-times/transit-time-form/transit-time-form.module'
import { CostFormService } from 'src/pages/admin/trading/deal-form/costs-form/costs-form.service'
import { CreateOfferFormService } from 'src/pages/admin/trading/deal-form/create-offer-form/create-offer-form.service'
import { DealAutocopyFormService } from 'src/pages/admin/trading/deal-form/deal-form-page/deal-autocopy-form/deal-autocopy-form.service'
import { DealFormPageOverlayModule } from 'src/pages/admin/trading/deal-form/deal-form-page/deal-form-page-overlay/deal-form-page-overlay.component.module'
import { DealFormPageModule } from 'src/pages/admin/trading/deal-form/deal-form-page/deal-form-page.module'
import { DealFormService } from 'src/pages/admin/trading/deal-form/deal-form-page/deal-form.service'
import { DealFormSnapshotsService } from 'src/pages/admin/trading/deal-form/deal-form-page/deal-form.service-snapshots'
import { NegativeMarginReasonFormService } from 'src/pages/admin/trading/deal-form/negative-margin-reason/negative-margin-reason.service'
import { DocumentsGeneratorService } from 'src/pages/admin/trading/deals/create-document/documents-generator.service'
import { DealDocumentsService } from 'src/pages/admin/trading/deals/deal-documents/deal-documents.service'
import { FilesService } from 'src/pages/admin/trading/deals/deal-documents/files.service'
import { DealDetailsOverlayModule } from 'src/pages/admin/trading/deals/list/actions/deal-details-overlay/deal-details-overlay.module'
import { DealFinanceOverlayModule } from 'src/pages/admin/trading/deals/list/actions/deal-finance-overlay/deal-finance-overlay.module'
import { ShipmentDetailsOverlayModule } from 'src/pages/admin/trading/deals/list/actions/shipment-details-overlay/shipment-details-overlay.module'
import { ShippingDetailsOverlayModule } from 'src/pages/admin/logistics/shipping-details-page/shipping-details-overlay/shipping-details-overlay.module'
import { SendConfirmationFormModule } from 'src/pages/admin/trading/deals/send-confirmation-form/send-confirmation-form.module'
import { EstimatesService } from 'src/pages/admin/trading/estimates/estimate/estimates.service'
import { LocksModule } from 'src/shared/lock/locks.module'
import { OnlineStatusService } from 'src/shared/lock/online-status.service'
import { MarkAsPaidFormService } from '../../components/invoices/mark-as-paid-form/mark-as-paid-form.service'
import { LogisticsClientShippingLogModule } from '../../pages/admin/logistics/client-shipping-log/client-shipping-log.module'
import { DistributionListOverlayModule } from '../../pages/admin/settings/companies/companies/actions/distribution-list-overlay/distribution-list-overlay.module'
import { ClientShippingLogModule } from '../../pages/admin/trading/client-shipping-log/client-shipping-log.module'
import { DealOverlaysService } from '../actions/deal-overlays.service'
import { DealSubmitService } from '../actions/deal-submit.service'
import { DealValidationService } from '../actions/deal-validation.service'
import { InvoiceFormsService } from '../actions/invoice-forms.service'
import { SegmentActionsService } from '../actions/segment-actions.service'
import { DealFinancialsListenerService } from '../deal-financials-listener'
import { MatchedOfferNotifierService } from '../matched-offer-notifier'
import { QueryService } from '../query.service'
import { AccountsService } from './accounts.service'
import { AESService } from './aes.service'
import { MontshipBookingService } from './montship-booking.service'
import { CostsService } from './costs.service'
import { CreditNotesService } from './credit-notes.service'
import { CreditPoolService } from './credit-pool.service'
import { CreditsExportModule } from './credits-export.module'
import { CustomCostsService } from './custom-costs.service'
import { DealCalculatorService } from './deal-calculator.service'
import { DealElasticSearchService } from './deal-elastic.service'
import { DealFormCalculatorService } from './deal-form-calculator.service'
import { DealViewPermissionsService } from './deal-view-permissions.service'
import { DealViewSaver2Service } from './deal-view-saver2.service'
import { DealsStoreService } from './deals-store.service'
import { DealsService } from './deals.service'
import { FileElasticSearchService } from './file-elastic.service'
import { ImportLogsElasticSearchService } from './import-logs-elastic.service'
import { InvoiceElasticSearchService } from './invoice-elastic.service'
import { InvoicesService } from './invoices.service'
import { ItemTypesService } from './item-types.service'
import { MacropointService } from './macropoint.service'
import { MatchedOfferPermissionsService } from './matched-offer-permissions.service'
import { MeasuresService } from './measures.service'
import { MessagesService } from './messages.service'
import { NotesService } from './notes.service'
import { OffersService } from './offers.service'
import { PackageTypesService } from './package-types.service'
import { PaymentOriginatorsService } from './payment-originators.service'
import { PrefixesService } from './prefixes.service'
import { ProductAttachmentsService } from './product-attachments.service'
import { SuffixesService } from './suffixes.service'
import { ProductCategoriesService } from './product-categories.service'
import { ProductTypesService } from './product-types.service'
import { ProductsService } from './products.service'
import { ReceiptsService } from './receipts.service'
import { RoutesService } from './routes.service'
import { ReceiptsElasticSearchService } from './receipts-elastic.service'
import { ShipmentsService } from './shipments.service'
import { SupplierOffersService } from './supplier-offers.service'
import { TableViewsService } from './table-views.service'
import { UnlocodesService } from './unlocodes.service'
import { UsersService } from './users.service'
import { VendorCreditsService } from './vendor-credits.service'
import { WeightTypesService } from './weight-types.service'
import { WrappingTypesService } from './wrapping-types.service'
import { CreditNotesElasticSearchService } from './credit-note-elastic.service'
import { VendorCreditsElasticSearchService } from './vendor-credit-elastic.service'
import { ShipmentRatesElasticSearchService } from 'src/pages/admin/logistics/freight-rates/shipment-rates-search.service'
import { SegmentsElasticSearchService } from './segments-elastic.service'
import { MaerskBookingService } from './maersk-booking.service'
import { MatchedOffersElasticSearchService } from '../../components/matched-offers/matched-offers-elastic.service'

@NgModule({
  // TODO: lazy load form modules after deprecating their downgraded versions
  imports: [
    ApiModule,
    DealFormPageModule,
    ReactiveFormsModule,
    CarrierPickerModule, // for the ng1 app. using it only in the deal-documents component
    CopyFreightRatesFormModule,
    AddressPickerModule,
    AddressFormModule,
    DealFormPageOverlayModule,
    InventoryDealsFormModule,
    DealFinanceOverlayModule,
    SendConfirmationFormModule,
    DealDetailsOverlayModule,
    ShipmentDetailsOverlayModule,
    ShippingDetailsOverlayModule,
    CreditNoteFormModule,
    VendorCreditFormModule,
    DistributionListOverlayModule,
    MacropointSegmentConfirmDialogModule,
    MacropointTrackDurationDialogModule,
    MatDialogModule, // remove after upgrading all ng1 modal dialogs and overlays
    NotesOverlayModule, // remove after upgrading all components and services which are using NotesOverlayService
    NoteFormModule, // remove after upgrading all components and services which are using NoteFormService
    ProductFormModule,
    LocksModule.forRoot(),
    ClientShippingLogModule,
    LogisticsClientShippingLogModule,
    DocumentFormModule,
    DocumentTagsOverlayModule,
    SupplierOfferOverlayModule,
    FreightRateFormModule,
    TransitTimeFormModule,
    MatchedOfferViewLogOverlayModule,
    FutureBidsListOverlayComponent,
    MatchedOfferOverlayModule,
    MacropointOrderLogOverlayModule,
    CostsListDialogModule,
    UploaderDialogModule,
    MacropointOrderTrackingModule,
    CompanyFormModule,
    CompanyLogOverlayModule,
    TemplateLogOverlayModule,
    TriggerLogOverlayModule,
    CompanyStatusFormModule,
    CompanyCreditFormModule,
    InvoiceScheduleFormModule,
    ReceiptFormModule,
    CreditsExportModule, // remove after upgrading vendor credits and credit notes pages,
  ],
  providers: [
    AddToBuyerGroupsService,
    CreateBuyerGroupService,
    AccountsService,
    CarriersService,
    CostsService,
    CustomTagsService,
    DealsService,
    DealViewPermissionsService,
    FilesService,
    FxRatesService,
    GeoService,
    LocationsService,
    MatchedOfferNotifierService,
    MatchedOfferPermissionsService,
    MessagesService,
    NotesService,
    OffersService,
    PaymentReferencesService,
    ProductsService,
    QueryService,
    ReceiptsService,
    ShipmentsService,
    SupplierOffersService,
    TableViewsService,
    TrackingProvidersService,
    UsersService,
    ItemTypesService,
    MeasuresService,
    PackageTypesService,
    PrefixesService,
    ProductAttachmentsService,
    SuffixesService,
    FinanceService,
    EstimatesService,
    InvoicesService,
    CountriesService,
    MatchedOffersService,
    FutureBidsListOverlayService,
    MatchedOfferBidHistoryOverlayService,
    FutureBidsApiService,
    VendorCreditsService,
    DealFinancialsListenerService,
    CreditNotesService,
    CreditPoolService,
    CustomCostsService,
    PackageTrackingService,
    PricingTermsService,
    DealCalculatorService,
    DealFormService,
    DealFormSnapshotsService,
    DealFormCalculatorService,
    WrappingTypesService,
    WeightTypesService,
    ProductTypesService,
    ProductCategoriesService,
    CurrenciesService,
    PaymentMethodsService,
    BanksService,
    PaymentOriginatorsService,

    // TODO: move to UI services module
    NegativeMarginReasonFormService,
    InventoryDealsFormService,
    DealOverlaysService,
    SaveViewFormService,
    ShareViewFormService,
    ConfigureColumnsService,
    SelectStatusNotesFormService,
    SegmentActionsService,
    CostFormService,
    EmailSelectService,
    CreateOfferFormService,
    MarkAsPaidFormService,
    AESService,
    MacropointService,
    MontshipBookingService,
    MaerskBookingService,
    RoutesService,
    UnlocodesService,

    // TODO: move out to separate modules
    DealValidationService,
    DealDocumentsService,
    DocumentsGeneratorService,
    DealSubmitService,
    CreateOfferFormService,
    DealAutocopyFormService,

    DealElasticSearchService,
    InvoiceElasticSearchService,
    DealViewSaver2Service,
    DealsStoreService,
    BuyerInvoiceReceiptsService,
    ReceiptsElasticSearchService,
    SegmentsElasticSearchService,
    ImportLogsElasticSearchService,
    CreditNotesElasticSearchService,
    VendorCreditsElasticSearchService,
    ShipmentRatesElasticSearchService,
    MatchedOffersElasticSearchService,


    FileElasticSearchService,
    InvoiceFormsService,
    CsvService,
    CsvFormatterService,
    OnlineStatusService,
  ],
})
export class DataModule { }
